import styled from 'styled-components';

export const NavBarContainer = styled.div`
    position:fixed;
    width:100%;
    top:0;
    left: 0;
    transition: all 0.3s ease-in;
    background-color: ${({bgColor}) => bgColor};
    z-index:1;
    


`
export const NavWrapper = styled.div`
  opacity: ${({ openMenu }) => (openMenu ? 0 : 1)};
  visibility: ${({ openMenu }) => (openMenu ? "hidden" : "visible")};
  pointer-events: ${({ openMenu }) => (openMenu ? "none" : "auto")};
  transition: all 0.3s ease-in-out;
`;


export const Logo = styled.p`
    font-size: 1.7rem;
    font-weight: ${({theme}) => theme.fonts.weight.medium };
    color: white;
`
export const MenuIcon = styled.a`
    color: ${({theme}) => theme.colors.secondary};
    font-size: 1.6rem;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;

`
export const NavMenuContainer = styled.div`
    
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: ${({theme})=> theme.colors.primary};
    z-index: 999;
    position:fixed;
`
export const MenuItem = styled.a`

    color: #fff;
    font-size: 2.5rem;
    margin-top: 3rem;
    cursor: pointer;
    text-decoration: none;
`

